import * as __SNOWPACK_ENV__ from './_snowpack/env.js';
import.meta.env = __SNOWPACK_ENV__;

import React, {StrictMode} from "./_snowpack/pkg/react.js";
import ReactDOM from "./_snowpack/pkg/react-dom.js";
import {App} from "./App.js";
import {initAdminClient} from "./context/auth/AdminClient.js";
import {initI18n} from "./i18n.js";
import "./index.css";
if (undefined /* [snowpack] import.meta.hot */ ) {
  undefined /* [snowpack] import.meta.hot */ .accept();
}
async function initialize() {
  const adminClient = await initAdminClient();
  await initI18n(adminClient);
  ReactDOM.render(/* @__PURE__ */ React.createElement(StrictMode, null, /* @__PURE__ */ React.createElement(App, {
    adminClient
  })), document.getElementById("app"));
}
initialize();
